<template>
    <v-checkbox v-model="conditions" :readonly="readonly" :required="required" :rules="required ? rules : []">
        <span slot="label">
            Das
            <data-protection-agreement-dialog>
                <a slot="activator" v-t="'data_protection'"></a>
            </data-protection-agreement-dialog>
            der Erziehungsberechtigten zur Speicherung der personenbezogenen Daten liegt mir vor{{ required ? '*' : '' }}
        </span>
    </v-checkbox>
</template>

<script>
    import DataProtectionAgreementDialog from '../dialogs/DataProtectionAgreementDialog';

    export default {
        components: {
            DataProtectionAgreementDialog
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value() {
                this.conditions = this.value;
            },
            conditions() {
                this.$emit('update:value', this.conditions);
            }
        },
        data: () => ({
            conditions: false,
            rules: [
                (v) => !!v || 'Einverständniserklärung muss akzeptiert werden'
            ]
        })
    }
</script>